// @flow
export const matchCurrentNav = (target, current) => {
  // The "target" is the desired section to match. E.g. "/journal/"
  // The "current" is the current path. E.g. "/journal/some-subdomain-here" or "/contact/"
  if (current && current.startsWith(target)) {
    return true;
  }
  return false;
};
